export let Industry;

(function (Industry) {
  Industry["MarketingAndAdvertising"] = "marketing-and-advertising";
  Industry["TechnologyAndServices"] = "information-technology-and-services";
  Industry["ComputerSoftware"] = "computer-software";
  Industry["RealEstate"] = "real-estate";
  Industry["FinancialServices"] = "financial-services";
  Industry["HealthWellnessAndFitness"] = "health-wellness-and-fitness";
  Industry["Education"] = "education-management";
  Industry["Consulting"] = "management-consulting";
})(Industry || (Industry = {}));

export let ACQ134Industry;

(function (ACQ134Industry) {
  ACQ134Industry["MarketingAndAdvertising"] = "marketing-and-advertising";
  ACQ134Industry["TechnologyAndServices"] = "technology-and-services";
  ACQ134Industry["RealEstate"] = "real-estate";
  ACQ134Industry["FinancialServices"] = "financial-services";
  ACQ134Industry["HealthWellnessAndFitness"] = "health-wellness-and-fitness";
  ACQ134Industry["Education"] = "education-management";
  ACQ134Industry["Consulting"] = "management-consulting";
  ACQ134Industry["Retail"] = "retail";
  ACQ134Industry["Construction"] = "construction";
})(ACQ134Industry || (ACQ134Industry = {}));

export const IndustryOptions = Object.values(Industry);
export const ACQ134IndustryOptions = Object.values(ACQ134Industry);